const getPipelineByKey = (state) => (key) =>
  state.pipelines.find((pipeline) => pipeline._key === key)

export default {
  getPipelineByKey,
}
